import { PermissionRoles } from '../models';

export const constants = {
  TABLE_ROWS: 25,
  KOR_BUSINESS_ACCOUNT_FILTER: 'rt_business_account_filter',
  KOR_BUSINESS_ACCOUNT_DOCUMENT_FILTER: 'rt_business_account_document_filter',
  KOR_FINANCIAL_ACCOUNT_FILTER: 'rt_financial_account_filter',
  TEAM_MEMBERS_FILTER: 'rt_team_member_filter',
  AUTH_ROUTE: '/auth',
  DEFAULT_TOKEN_EXPIRE_IN_SECONDS: 300,
  DEFAULT_REALM_NAME: 'admin',
  ENCRYPTION_KEY: 'ThVmYq3t6w9z$C&F)J@NcRfUjXnZr4u7',
  HOME_ROUTE: '/app/business-accounts',
  SENTRY_DSN: 'https://adb7a0e386b043f5825d4c99ce0638d2@o923818.ingest.sentry.io/4504056329273344',
  SENTRY_PROD_DSN: 'https://24fd7115e7b242bbb52b9efe8da1cb5d@o923818.ingest.sentry.io/4504673585463296',
};

/**
 * The KOR sponsor Business Account every tenant's root Business Account hangs off. A tenant root has this as its
 * `parentId`; a child Business Account has its tenant's id instead.
 */
export const KOR_SPONSOR_PARENT_ACCOUNT_ID = '22222222-2222-2222-2222-222222222222';

export const MESSAGE = {
  PERMISSION_DENIED: 'Permission denied. Please contact Administrator.',
  PERMISSION_DENIED_TITLE: 'Permission denied',
  PERMISSION_DENIED_NOTIFICATION: 'You need permission to perform this action.',
  PERMISSION_DENIED_NOTIFICATION_TITLE: 'Permission Denied',
  SESSION_EXPIRED_NOTIFICATION: 'Please login again to resume.',
  SESSION_UNAVAILABLE_NOTIFICATION: 'The server encountered an error and could not complete your request.',
  PAGE_NOT_FOUND_NOTIFICATION: 'Page not found.',
  SESSION_EXPIRED_NOTIFICATION_TITLE: 'Session Expired',
  LOGIN_ERROR: 'Oops! The email or password entered was incorrect. Please try again.',
  CURRENT_PASSWORD_INCORRECT: 'The current password you entered is incorrect. Please try again.',
  PASSWORD_EXPIRY_REAUTH_REQUIRED: 'For your security, please re-enter your current password to set a new one.',
  PASSWORD_EXPIRY_SUCCESS: 'Your password has been updated. Please sign in with your new password.',
  AUTH_PROVIDER_VERIFICATION_ERROR: 'Oops! Unable to verify auth provider. Please contact administrator.',
  UNKNOWN_ERROR: 'Oops! We are unable to complete this request. Please contact administrator.',
  TEAM_MEMBER_ALREADY_EXIST: 'A Team Member account with this email address already exists.',
  GENERIC_ERROR: 'Oops! The information entered was incorrect. Please check and try again.',
};

// PCI password-expiry recovery flow (KOR-14853). Returned in the error body's `errorCode`.
export const AUTH_ERROR_CODE = {
  passwordExpired: 'password-expired',
  invalidProviderToken: 'invalid-provider-token',
} as const;

// Minimum password length required by the PCI expiry contract (KOR-14853), applied to every
// password-entry screen per KOR-14897.
export const MIN_PASSWORD_LENGTH = 12;

export const BUSINESS_TYPES = [
  { value: 'SP', label: 'Individual / Sole Proprietor (SP)' },
  { value: 'SMLLC', label: 'Single-Member LLC (SMLLC)' },
  { value: 'LLC', label: 'Limited Liability Company (LLC)' },
  { value: 'PLLC', label: 'Professional LLC (PLLC)' },
  { value: 'C_CORP', label: 'C Corporation (C-Corp)' },
  { value: 'S_CORP', label: 'S Corporation (S-Corp)' },
  { value: 'CORP', label: 'Corporation (Corp)' },
  { value: 'PC', label: 'Professional Corporation (PC)' },
  { value: 'COOP', label: 'Cooperative (Co-op)' },
  { value: 'PARTNERSHIP', label: 'Partnership' },
  { value: 'GP', label: 'General Partnership (GP)' },
  { value: 'LP', label: 'Limited Partnership (LP)' },
  { value: 'LLP', label: 'Limited Liability Partnership (LLP)' },
  { value: 'LLLP', label: 'Limited Liability Limited Partnership (LLLP)' },
  { value: 'TRUST_ESTATE', label: 'Trust / Estate' },
  { value: 'NPO', label: 'Nonprofit Organization (NPO)' },
  { value: 'GOVERNMENT', label: 'Government Entity' },
];

export const ROLES: { label: string; value: PermissionRoles }[] = [
  { label: 'Admin', value: 'Admin' },
  { label: 'Clerk', value: 'Clerk' },
  { label: 'Finance', value: 'Finance' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Owner', value: 'Owner' },
  { label: 'View Only', value: 'View Only' },
];

export const ALLOWED_ATTACHMENT_FILE_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

export const COUNTRY_CODES: Record<string, string> = {
  USA: 'USD',
  AZ: 'AZN',
};
